import { BREAKPOINTS } from 'constants/breakpoints';
import { useEffect, useState } from 'react';

export const useDimensions = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    });

    return () =>
      window.addEventListener('resize', () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
      });
  }, []);

  return {
    isSmallWidth: width < BREAKPOINTS.small,
    isMediumWidth: width < BREAKPOINTS.medium,
    isLargeWidth: width >= BREAKPOINTS.medium,
    width,
    height,
  };
};
